export const TERMINAL_PARTNERS = {
  stationMascot: {
    shortName: 'stationMascot'
  },
  riverpay: {
    shortName: 'riverpay'
  },
}
